export default __webpack_public_path__ + "static/media/musa.fbc2075f.png";